// System tab fields

import { Item as I } from '../../../../services/itemUtils';
import { FIELDS as F } from '../../../../services/consumerFields';
import * as C from '../../../../services/marketConfig';

export function getFields(L, market) {
    const items = [
        I.new(L.consumerpage_system_field_consumer_id, F.UID).build(),
        I.new(L.consumerpage_system_field_created, F.CREATED_DATE)
            .datetime(C.getMarketValue(C.MARKET_FORMAT_DATETIME, market))
            .build(),
        I.new(L.consumerpage_system_field_registered, F.IS_REGISTERED)
            .bool(L.dict_yesno.yes, L.dict_yesno.no)
            .build(),
        I.new(L.consumerpage_system_field_registration_time, F.REGISTERED_DATE)
            .datetime(C.getMarketValue(C.MARKET_FORMAT_DATETIME, market))
            .build(),
        I.new(L.consumerpage_system_field_login_allowed, F.IS_ACTIVE)
            .bool(L.dict_yesno.yes, L.dict_yesno.no)
            .build(),
        I.new(L.consumerpage_system_field_last_login, F.LAST_LOGIN_DATE)
            .datetime(C.getMarketValue(C.MARKET_FORMAT_DATETIME, market))
            .build(),
        I.new(L.consumerpage_system_field_last_updated, F.LAST_UPDATED_DATE)
            .datetime(C.getMarketValue(C.MARKET_FORMAT_DATETIME, market))
            .build(),
        I.new(L.consumerpage_system_field_last_updated_by, F.LAST_UPDATED_BY)
            .dropdown(L.dict_last_updated_by)
            .build(),
    ];

    return [{ id: 1, items }];
}
